import {
    Tally, Per, Product, ProductPer, Product2, QuickPurchaseLine,
    QuickPurchaseLineLineType
} from 'ep-bt-field-agent-proxy';
import { EpbtFaTallyModel } from '../models/epbt-fa-tally.model';

export class EpbtFaQuickPurchaseLineModel {
    // line = new QuickPurchaseLine();
    constructor(product: Product2) {
        this.adding = true;
        // this.isTallyLine = this.isTallyLine();
        this.product = product;
        this.per = new Per();
        this.tally = new EpbtFaTallyModel();
        this.lineType = QuickPurchaseLineLineType.ProductLine;
        this.quantity = 0;
        this.quantityTally = null;
        this.inputPer = product.inputPer ? product.inputPer : null;
        // this.perID = product.inputPer.perId;
        this.perID = this.inputPer ? this.inputPer.perId : null;
        // this.inputperCode = this.inputPer ? this.inputPer.perCode : '';
    }
    adding?: boolean | undefined;
    // isTallyLine?: boolean | undefined;
    product?: Product2 | undefined;
    per?: Per | undefined;
    tally?: EpbtFaTallyModel | undefined;
    lineType?: QuickPurchaseLineLineType | undefined;
    quantity?: number | undefined;
    quantityTally?: string | undefined;
    inputPer?: Per | undefined;

    private _inputperCode = '';
    get inputperCode(): string {
        return this.inputPer ? this.inputPer.perCode : '';
    }


    // inputperCode: string = '';
    lineNumber?: number | undefined;
    perID?: number | undefined;

    // created to maintain the selected per from per dropdown
    public selectedPer?: ProductPer | undefined;

    public get isTallyLine(): boolean {
        return this.shouldTallyProduct(this.product.tallyLengths);
    }

    public shouldTallyProduct(tallyLengths: string): boolean {
        // Do not tally if there is no tally length value at all.
        // Do not tally if there is only a single tally length (i.e. no comma).
        return tallyLengths != null && tallyLengths != '' && tallyLengths.includes(',');
    }
}
